import React from 'react';

export const ModuleDivider = () => {
  return <hr />;
};
